<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-18 10:27:39
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-12-21 10:17:55
-->
<template>
  <div class="index-hxcp wh100">
    <div class="container index-hxcp-box wh100 flex flex_col">
      <div class="index-hxcp-title">
        <div class="ui-title p-t-10">{{ $t('frontPage.hexinchanping.title') }}</div>
        <div class="ui-des">
          <p v-for="$item, $index in $t('frontPage.hexinchanping.des')" :key="$index" v-html="$item"></p>
        </div>
      </div>
      <div ref="mainBox" class="index-hxcp-main flex_1 posrel flex flex_col align_items_center">
        <div class="flex index-hxcp-wrap">
          <div class="flex_1 p-b-30">
            <div class="textc">
              <img class="index-hxcp-main-img" :src="$t('frontPage.hexinchanping.innovative.skull.img')" alt="" srcset="">
              <p class="index-hxcp-main-title" v-html="$t('frontPage.hexinchanping.innovative.skull.title')" @click="jumpPath(`/innovative/${$t('frontPage.hexinchanping.innovative.skull.more')}`)"></p>
            </div>
            <div>
              <div class="flex index-hxcp-item" v-for="item, index in $t('frontPage.hexinchanping.innovative.skull.list')" :key="index">
                <div class="index-hxcp-item-title m-r-30" @click="jumpPath(item.path)" v-html="item.title"></div>
                <div class="flex_1">
                  <el-tooltip :disabled="index == 0 ? skull1 : index == 1 ? skull2 : index == 2 ? skull3 : skull4">
                    <div class="index-hxcp-item-des multiLineText" v-html="item.des" @click="jumpPath(item.path)" @mouseenter="projectMouseenter($event, `skull${index + 1 }`)" @mouseleave="projectMouseleave()"></div>
                    <div slot="content" v-html="item.des"></div>
                  </el-tooltip>
                </div>
              </div>
              <div class="index-hxcp-item-more l-156" v-html="$t('frontPage.hexinchanping.innovative.more')" @click="jumpPath( `/innovative/${$t('frontPage.hexinchanping.innovative.skull.more')}`)"></div>
            </div>
          </div>
          <div class="flex_1 flex justify_content_center align_items_center posrel index-hxcp-middle">
            <div class="index-hxcp-middle-box flex flex_col justify_content_center align_items_center">
              <div class="flex flex_col justify_content_center align_items_center posrel">
                <div class="index-hxcp-middle-left flex align_items_center">
                  <img class="" :src="require('@/assets/images/pc/index/hxcp/bj_left.png')" alt="" srcset="">
                </div>
                <div class="index-hxcp-middle-right flex align_items_center">
                  <img class="" :src="require('@/assets/images/pc/index/hxcp/bj_right.png')" alt="" srcset="">
                </div>
                <img class="index-hxcp-middle-circle" :src="$t('frontPage.hexinchanping.innovative.img_circle')" alt="" srcset="">
                <img class="index-hxcp-middle-circle_arraw" :src="require('@/assets/images/index/hxcp/circle_arraw.png')" alt="" srcset="">
                <div class="flex justify_content_center align_items_center">
                  <div class="mini-circle flex flex_col justify_content_center align_items_center" v-for="item, index in $t('frontPage.hexinchanping.innovative.circle_list')" :key="index">
                    <img :src="item.img" alt="" srcset="">
                    <div class="p-t-8" v-html="item.title"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex_1 p-b-30">
            <div class="textc">
              <img class="index-hxcp-main-img" :src="$t('frontPage.hexinchanping.innovative.heart.img')" alt="" srcset="">
              <p class="index-hxcp-main-title" v-html="$t('frontPage.hexinchanping.innovative.heart.title')" @click="jumpPath(`${language == 'en' ? '/en' : ''}/innovative/${$t('frontPage.hexinchanping.innovative.heart.more')}`)"></p>
            </div>
            <div>
              <div class="flex index-hxcp-item" v-for="item, index in $t('frontPage.hexinchanping.innovative.heart.list')" :key="index">
                <div class="flex_1">
                  <el-tooltip :disabled="index == 0 ? heart1 : index == 1 ? heart2 : heart3">
                    <div class="index-hxcp-item-des multiLineText" v-html="item.des" @click="jumpPath(item.path)" @mouseenter="projectMouseenter($event, `heart${index + 1 }`)" @mouseleave="projectMouseleave()"></div>
                    <div slot="content" v-html="item.des"></div>
                  </el-tooltip>
                </div>
                <div :class="['index-hxcp-item-title m-l-16']" @click="jumpPath(item.path)" v-html="item.title"></div>
              </div>
              <div class="index-hxcp-item-more" v-html="$t('frontPage.hexinchanping.innovative.more')" @click="jumpPath( `${language == 'en' ? '/en' : ''}/innovative/${$t('frontPage.hexinchanping.innovative.heart.more')}`)"></div>
            </div>
          </div>
        </div>
        <div v-if="language == 'en'" class="index-hxcp-bottom">
          <div class="wh100 posrel flex flex_col align_items_center">
            <!-- <div class="index-hxcp-bottom-bj">
              <img class="" :src="require('@/assets/images/pc/index/hxcp/en/bottom.png')" alt="" srcset="">
            </div> -->
            <div class="flex index-hxcp-bottom-t">
              <img class="wid100" :src="require('@/assets/images/pc/index/hxcp/en/top.png')" alt="" srcset="">
            </div>
            <div class="index-hxcp-bottom-arraw">
              <img class="" :src="require('@/assets/images/pc/index/hxcp/arraw.png')" alt="" srcset="">
            </div>
            <div class="flex index-hxcp-bottom-b">
              <img class="wid100" :src="require('@/assets/images/pc/index/hxcp/en/bottom.png')" alt="" srcset="">
            </div>
          </div>
        </div>
        <div v-else class="index-hxcp-bottom">
          <div class="wh100 posrel flex flex_col align_items_center">
            <div class="index-hxcp-bottom-bj">
              <img class="" :src="require('@/assets/images/pc/index/hxcp/bottom.png')" alt="" srcset="">
            </div>
            <el-row :gutter="30" class="flex index-hxcp-bottom-t">
              <el-col class="index-hxcp-bottom-t-item flex align_items_center justify_content_center" v-for="item, index in $t('frontPage.hexinchanping.innovative.t_list')" :key="index">
                <img class="" :src="item" alt="" srcset="">
              </el-col>
            </el-row>
            <div class="index-hxcp-bottom-arraw">
              <img class="" :src="require('@/assets/images/pc/index/hxcp/arraw.png')" alt="" srcset="">
            </div>
            <div class="flex index-hxcp-bottom-b">
              <div class="list textc" v-for="item, index in $t('frontPage.hexinchanping.innovative.b_list')" :key="index">
                <img class="" :src="item" alt="" srcset="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    realIndex: {
      type: Number,
      default: 0
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      skull1: true,
      skull2: true,
      skull3: true,
      skull4: true,
      heart1: true,
      heart2: true,
      heart3: true
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  watch: {
    realIndex (newValue) {
      if (newValue === this.activeIndex) {
        document.body.className += 'overhid'
      } else {
        document.body.classList.remove('overhid')
      }
    }
  },
  methods: {
    jumpPath (_path) {
      this.$router.push({ path: _path })
    },
    projectMouseenter (ev, name) {
      const div = document.createElement('div')
      div.style.position = 'absolute'
      div.style.width = ev.target.clientWidth + 'px'
      const bodyW = document.body.clientWidth
      div.style.top = '-100000px'
      div.style.left = '-100000px'
      div.style.fontSize = (bodyW > 1600 ? 16 : bodyW <= 1280 ? 12 : 14) + 'px'
      div.style.lineHeight = '22px'
      div.innerHTML = ev.target.innerHTML
      div.className = 'product_tooltip'
      document.body.appendChild(div)
      this.$nextTick(() => {
        const productTooltip = document.getElementsByClassName('product_tooltip')
        const height = productTooltip[productTooltip.length - 1].clientHeight
        this[name] = !(height - 10 > ev.target.clientHeight)
      })
    },
    projectMouseleave () {
      this.skull1 = true
      this.skull2 = true
      this.skull3 = true
      this.skull4 = true
      this.heart1 = true
      this.heart2 = true
      this.heart3 = true
      const productTooltip = document.getElementsByClassName('product_tooltip')
      for (let i = 0; i < productTooltip.length; i++) {
        document.body.removeChild(productTooltip[i])
      }
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes slideUp {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
    -moz-transform: translate3d(0, 100%, 0);
    -ms-transform: translate3d(0, 100%, 0);
    -o-transform: translate3d(0, 100%, 0);
    opacity: 0.2;
  }
  20% {
    -webkit-transform: translate3d(0, 50%, 0);
    transform: translate3d(0, 50%, 0);
    -moz-transform: translate3d(0, 50%, 0);
    -ms-transform: translate3d(0, 50%, 0);
    -o-transform: translate3d(0, 50%, 0);
    opacity: 0.2;
  }
  50%, 100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    opacity: 1;
  }
}
.pc .index-hxcp {
  color: #333333;
  padding-top: 90PX;
  .index-hxcp-box {
    position: relative;
  }
  .index-hxcp-title {
  }
  .index-hxcp-main {
    .index-hxcp-wrap {
      position: relative;
    }
    .index-hxcp-main-title {
      font-size: 18PX;
      font-weight: 600;
      padding-top: 16PX;
      padding-bottom: 20PX;
      position: relative;
      z-index: 2;
      cursor: pointer;
      &:hover {
        color: #0069B3;
      }
    }
    .index-hxcp-item {
      line-height: 22PX;
      padding: 12PX 0;
      position: relative;
      .index-hxcp-item-title {
        background-color: #00A1E9;
        background-image: url('~@/assets/images/pc/index/hxcp/btn_box.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        width: 126PX;
        line-height: 34PX;
        color: #ffffff;
        height: 34PX;
        text-align: center;
        cursor: pointer;
        margin-top: 6PX;
        position: relative;
        z-index: 2;
        &:hover {
          background-color: #0069B3;
        }
      }
      .index-hxcp-item-des {
        cursor: pointer;
        text-align: justify;
        position: relative;
        z-index: 2;
        -webkit-line-clamp: 2;
        &:hover {
          color: #0069B3;
        }
      }
    }
    .index-hxcp-item-more {
      color: #00A1E9;
      display: inline-block;
      cursor: pointer;
      position: relative;
      margin-top: 8PX;
      &:hover {
        color: #0069B3;
      }
    }
    .index-hxcp-middle {
      .index-hxcp-middle-box {
        position: relative;
        margin-top: 30PX;
      }
      .index-hxcp-middle-left, .index-hxcp-middle-right {
        position: absolute;
        height: 100%;
      }
      .index-hxcp-middle-left {
        right: 70%;
      }
      .index-hxcp-middle-right {
        left: 70%;
      }
      .index-hxcp-middle-circle {
        max-width: 435PX;
        position: relative;
        margin: 30PX;
      }
      .index-hxcp-middle-circle_arraw {
        max-width: 402PX;
        position: absolute;
        margin-right: 4PX;
        animation: refresh-rotate 10s linear infinite;
      }
      .mini-circle {
        position: absolute;
        z-index: 3;
        width: 120PX;
        height: 120PX;
        border-radius: 50%;
        background: #ffffff;
        box-shadow: 2PX 2PX 12PX 4PX rgba(81, 170, 255, 0.3);
        font-size: 20PX;
        font-weight: bold;
        &:nth-of-type(1) {
          top: 20PX;
        }
        &:nth-of-type(2) {
          left: 40PX;
          bottom: 100PX;
        }
        &:nth-of-type(3) {
          right: 40PX;
          bottom: 100PX;
        }
      }
    }
  }
  .index-hxcp-bottom {
    position: absolute;
    width: 90%;
    padding: 0 16%;
    bottom: 9PX;
    .index-hxcp-bottom-bj {
      position: absolute;
      width: 100%;
      bottom: 40PX;
      img {
        width: 100%;
      }
    }
    .index-hxcp-bottom-arraw {
      position: absolute;
      bottom: 76PX;
      width: 90%;
      padding-left: 3%;
      img {
        width: 100%;
      }
      animation: slideUp 3s linear infinite;
    }
    .index-hxcp-bottom-t {
      position: absolute;
      bottom: 150PX;
      width: 110%;
      padding-left: 2%;
      height: 30PX;
      overflow: hidden;
      img {
        max-height: 100%;
        max-width: 100%;
      }
      .index-hxcp-bottom-t-item {
        &:nth-of-type(1) {
          width: 26.4%;
        }
        &:nth-of-type(2) {
          width: 27.6%;
        }
        &:nth-of-type(3) {
          width: 23.4%;
        }
        &:nth-of-type(4) {
          width: 22.6%;
        }
      }
    }
    .index-hxcp-bottom-b {
      position: absolute;
      bottom: 0;
      width: 116%;
      height: 56PX;
      margin-left: -2%;
      margin-right: -2%;
      img {
        height: 100%;
      }
      .list {
        width: 25%;
        padding: 0 4%;
      }
    }
  }
}
.pc.en .index-hxcp {
  .index-hxcp-main {
    .index-hxcp-wrap {
      top: -20PX;
    }
    .index-hxcp-main-img {
      -webkit-transform: scale(0.76);
      transform: scale(0.7);
      -moz-transform: scale(0.7);
      -ms-transform: scale(0.7);
      -o-transform: scale(0.7);
      position: relative;
      top: 8PX;
    }
    .index-hxcp-main-title {
      line-height: 30PX;
      padding-top: 10PX;
      padding-bottom: 15PX;
    }
    .index-hxcp-item {
      .index-hxcp-item-des {
        text-align: left;
      }
    }
    .index-hxcp-middle {
      .mini-circle {
        font-size: 16PX;
      }
    }
    .index-hxcp-bottom {
      .index-hxcp-bottom-t {
        height: auto;
      }
      .index-hxcp-bottom-b{
        height: auto;
      }
    }
  }
}
</style>

<style lang="less">
.pc .el-tooltip__popper.is-dark {
  left: -100000px;
  top: -100000px;
}
</style>

<style lang="less" scoped>
@media screen and (min-width: 1920PX) {
  .pc .index-hxcp {
    .index-hxcp-bottom {
      .index-hxcp-bottom-t {
        bottom: 170PX;
      }
    }
  }
}
@media screen and (min-width: 1700PX) and (max-width: 1900PX){
  .pc .index-hxcp {
    .index-hxcp-wrap {
      top: -30PX;
    }
  }
}
@media screen and (max-width: 1700PX) and (min-width: 1600PX){
  .pc {
    .index-hxcp {
      .index-hxcp-main .index-hxcp-wrap {
        top: -30PX;
      }
      .index-hxcp-bottom {
        .index-hxcp-bottom-bj {
          width: 90%;
        }
        .index-hxcp-bottom-t {
          // width: 100%;
          bottom: 110PX;
        }
        .index-hxcp-bottom-arraw {
          // width: 78%;
          bottom: 70PX;
          height: 40PX;
        }
      }
    }
    &.en {
      .index-hxcp {
        // background: red;
        .index-hxcp-main .index-hxcp-wrap {
          top: -50PX;
        }
      }
    }
  }
}
@media screen and (max-width: 1600PX) {
  .pc .index-hxcp {
    .index-hxcp-title {
      .ui-title {
        font-size: 26PX;
        line-height: 64PX;
        &::before {
          width: 100PX;
          left: calc(50% - 50PX);
        }
      }
    }
    .index-hxcp-main {
      font-size: 14PX;
      .index-hxcp-main-title {
        font-size: 16PX;
      }
      .index-hxcp-item {
        line-height: 22PX;
        padding: 4PX 0;
        position: relative;
        .index-hxcp-item-title {
          line-height: 26PX;
          height: 26PX;
          margin-top: 6PX;
        }
      }
      .index-hxcp-middle {
        .index-hxcp-middle-circle {
          max-width: 300PX;
        }
        .index-hxcp-middle-circle_arraw {
          max-width: 274PX;
        }
        .mini-circle {
          width: 90PX;
          height: 90PX;
          font-size: 16PX;
          &:nth-of-type(1) {
            top: 15PX;
          }
          &:nth-of-type(2) {
            left: 30PX;
            bottom: 70PX;
          }
          &:nth-of-type(3) {
            right: 30PX;
            bottom: 70PX;
          }
        }
      }
    }
    .index-hxcp-bottom {
      width: 90%;
      .index-hxcp-bottom-bj {
        bottom: 30PX;
      }
      .index-hxcp-bottom-arraw {
        width: 88%;
        bottom: 50PX;
      }
      .index-hxcp-bottom-t {
        bottom: 120PX;
        height: 22PX;
      }
      .index-hxcp-bottom-b {
        height: 40PX;
        width: 108%;
      }
    }
  }
}
@media screen and (min-width: 1440PX) and (max-width: 1600PX) and (max-height: 880PX) {
  .pc .index-hxcp {
    .index-hxcp-wrap {
      top: -70PX;
    }
  }
}
@media screen and (max-width: 1440PX) and (max-height: 900px) {
  .pc .index-hxcp {
    .index-hxcp-title {
      .ui-des {
        font-size: 16PX;
      }
    }
    .index-hxcp-wrap {
      top: -30PX;
    }
    .index-hxcp-bottom {
      .index-hxcp-bottom-t {
        bottom: 110PX;
      }
    }
  }
}
@media screen and (max-width: 1360PX) and (max-height: 768px) {
  .pc .index-hxcp {
    .index-hxcp-main {
      .index-hxcp-middle {
        .index-hxcp-middle-box {
          margin-top: 80PX;
        }
      }
    }
  }
}
@media screen and (max-height: 660PX) {
  .pc .index-hxcp {
    padding-top: 46PX;
    .index-hxcp-main {
      font-size: 12PX;
      .index-hxcp-wrap {
        top: -80PX;
      }
    }
    .index-hxcp-title {
      .ui-des {
        font-size: 14PX;
      }
    }
    .index-hxcp-bottom {
      .index-hxcp-bottom-bj {
        bottom: 20PX;
      }
      .index-hxcp-bottom-arraw {
        bottom: 36PX;
      }
      .index-hxcp-bottom-t {
        bottom: 90PX;
      }
      .index-hxcp-bottom-b {
        height: 36PX;
      }
    }
  }
}
@media screen and (max-width: 1280PX) and (max-height: 700PX) {
  .pc .index-hxcp {
    padding-top: 46PX;
    .index-hxcp-main {
      font-size: 12PX;
      .index-hxcp-wrap {
        top: -80PX;
      }
    }
    .index-hxcp-title {
      .ui-des {
        font-size: 14PX;
      }
    }
    .index-hxcp-bottom {
      .index-hxcp-bottom-bj {
        bottom: 20PX;
      }
      .index-hxcp-bottom-arraw {
        bottom: 36PX;
      }
      .index-hxcp-bottom-t {
        bottom: 90PX;
      }
      .index-hxcp-bottom-b {
        height: 36PX;
      }
    }
  }
}
</style>
